import { constants } from "../constants";
import { StringFormat } from "../Util/stringutil";
import { Stat, Status } from "./entity/statusEntity";
import { myFetch } from "./myFetch";
import {
  InsertTaskTemplateResponse,
  ResponseTaskTemplateResponse,
  TaskTemplate,
} from "./entity/TaskTemplateOperationEntity";

export default interface ITaskTemplateOperation {
  postTaskTemplateAsync(
    corpId: number,
    template: TaskTemplate,
  ): Promise<Stat<InsertTaskTemplateResponse>>;

  putTaskTemplateAsync(
    corpId: number,
    templateId: string,
    template: TaskTemplate,
  ): Promise<Status>;

  deleteTaskTemplateAsync(corpId: number, templateId: string): Promise<Status>;

  getTaskTemplateAsync(
    corpId: number,
    page: number,
    pageSize: number,
  ): Promise<ResponseTaskTemplateResponse>;
}

export class TaskTemplateOperation implements ITaskTemplateOperation {
  async getTaskTemplateAsync(
    corpId: number,
    page: number,
    pageSize: number,
  ): Promise<ResponseTaskTemplateResponse> {
    const response = await myFetch<ResponseTaskTemplateResponse>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_TASK_TEMP_ENDPOINT,
        corpId,
        page,
        pageSize,
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      },
    );

    if (response.status === 200) {
      const data = await response.json();
      const payload = data as ResponseTaskTemplateResponse & {
        data?: ResponseTaskTemplateResponse;
      };
      const wrappedResults = payload.data?.results;
      const rawResults = Array.isArray(payload?.results)
        ? payload.results
        : Array.isArray(wrappedResults)
        ? wrappedResults
        : [];

      const normalizedResults = rawResults.map((item) => {
        const row = item as unknown as {
          id?: string;
          taskTemplateId?: string;
          templateId?: string;
          companyId?: number;
          corporationId?: number;
          name: string;
          description?: string;
          category?: string;
          branchId?: number;
          branchName?: string;
          items?: unknown[];
          isDefault?: boolean;
          isActive?: boolean;
          activeInd?: boolean;
          createdBy?: string;
          createdDate?: string;
          createdDateTimeUTC?: string;
        };

        return {
          ...row,
          taskTemplateId: row.taskTemplateId || row.id || row.templateId || "",
          corporationId: row.corporationId ?? row.companyId ?? corpId,
          items: Array.isArray(row.items) ? row.items : [],
          isDefault: !!row.isDefault,
          activeInd: row.activeInd ?? !!row.isActive,
          createdBy: row.createdBy || "",
          createdDateTimeUTC:
            row.createdDateTimeUTC ||
            row.createdDate ||
            new Date().toISOString(),
        };
      });

      return {
        currentPage: payload.currentPage ?? payload.data?.currentPage ?? 1,
        pageCount: payload.pageCount ?? payload.data?.pageCount ?? 0,
        pageSize: payload.pageSize ?? payload.data?.pageSize ?? 0,
        rowCount: payload.rowCount ?? payload.data?.rowCount ?? 0,
        firstRowOnPage:
          payload.firstRowOnPage ?? payload.data?.firstRowOnPage ?? 0,
        lastRowOnPage:
          payload.lastRowOnPage ?? payload.data?.lastRowOnPage ?? 0,
        results: normalizedResults,
      };
    }
    return {
      results: [],
      currentPage: 1,
      pageCount: 0,
      pageSize: 0,
      rowCount: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
    };
  }

  async putTaskTemplateAsync(
    corpId: number,
    templateId: string,
    template: TaskTemplate,
  ): Promise<Status> {
    const response = await myFetch<Stat<InsertTaskTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.PUT_TASK_TEMP_ENDPOINT,
        corpId,
        templateId,
      )}`,
      {
        method: "PUT",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(template),
      },
    );

    const data = await response.json();
    return data;
  }

  async deleteTaskTemplateAsync(
    corpId: number,
    templateId: string,
  ): Promise<Status> {
    const response = await myFetch<Stat<InsertTaskTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.DELETE_TASK_TEMP_ENDPOINT,
        corpId,
        templateId,
      )}`,
      {
        method: "DELETE",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify({}),
      },
    );

    const data = await response.json();
    return data;
  }

  async postTaskTemplateAsync(
    corpId: number,
    template: TaskTemplate,
  ): Promise<Stat<InsertTaskTemplateResponse>> {
    const response = await myFetch<Stat<InsertTaskTemplateResponse>>(
      `${constants.BASE_URL}${StringFormat(
        constants.POST_TASK_TEMP_ENDPOINT,
        corpId,
      )}`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: ``,
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        }),
        body: JSON.stringify(template),
      },
    );

    const data = await response.json();
    return data;
  }
}
